const RENTER_HUB = 'Renter Hub';

const StringConstants = {
  APP_NAME: 'satellite-rachel-web',
  BASE_PATH: '/renter-hub/inbox',
  HOTPADS_APP_TITLE: 'Messages',
  ZILLOW_APP_TITLE: 'Inbox',
  INBOX_PAGE_HEAD_TITLE: `Inbox | ${RENTER_HUB}`,
  ZILLOW_INBOX_PAGE_HEAD_TITLE: 'Inbox | Zillow',
  HOTPADS_INBOX_PAGE_HEAD_TITLE: 'Messages | HotPads',
  NOT_FOUND_PAGE_TITLE: `Page Not Found | ${RENTER_HUB}`,
  ERROR_PAGE_TITLE: `Error | ${RENTER_HUB}`,

  //http method types
  GET: 'get',
  PUT: 'put',
  POST: 'post',
  DELETE: 'delete',

  // direction
  NEXT: 'next',
  PREV: 'prev',

  FORMATTED_BRAND_NAMES: {
    hotpads: 'HotPads',
    zillow: 'Zillow',
    trulia: 'Trulia',
  },

  // using the plain brand names for hotpads and trulia for now whenever we need to use ZRM brand for zillow
  FORMATTED_BRAND_NAMES_RENTAL: {
    hotpads: 'HotPads',
    zillow: 'Zillow Rental Manager',
    trulia: 'Trulia',
  },

  UNFORMATTED_BRAND_NAMES: {
    hotpads: 'hotpads',
    zillow: 'zillow',
    trulia: 'trulia',
  },

  DEVTOOLS_SUPPORTED_BRAND_NAMES: {
    hotpads: 'hotpads',
    zillow: 'zillow',
  },

  GA_TRACKERS: {
    hotpads: 'hotpads',
    zillow: 'zillow',
    trulia: 'trulia',
    gtm: 'gtm',
  },

  // marketing
  MARKETING_PATH: {
    PAYMENTS: 'payments',
    APPLICATIONS: 'applications',
  },

  ALLOW_PARAMS_REGEX: '([?].*)?([&].*)?',

  // server side error string identifier
  // only for BE status code > 399 that are to be fixed in near future
  SS_ERRORS: {
    confirm_phone_number: 'Please confirm the contact phone number.',
  },

  CONVERSATION_PAGE_VIEW_TYPE: {
    ALL: 'all', // Unused for now as this will be default
    PROPERTY: 'property',
  },

  GRAPHQL_ERROR_TYPES: {
    AUTHENTICATION: 'authentication_error',
    AUTHORIZATION: 'authorization_error',
    BAD_REQUEST: 'bad_request_error',
    DEFAULT: 'api_error',
    INTERNAL_SERVER: 'internal_server_error',
    NETWORK: 'network_error',
    RESOURCE_NOT_FOUND: 'resource_not_found',
    UNAUTHENTICATED: 'UNAUTHENTICATED',
  },

  //TODO: revisit this for actual url
  REGEX: {
    CONVERSATION_PAGE_PARAMS: '/:conversationId(\\d+)?',
  },

  TOOLTIP: {
    BLOCKED: 'Cannot reply to a conversation that has been blocked by Zillow.',
    REPORTED: 'Cannot reply to a conversation that has been reported.',
    IMPERSONATION: 'Disabled while impersonating',
    IMPERSONATION_VIEW: 'Cannot view while impersonating',
    PHONE_LEAD:
      'To reply to this renter, please call or text their number directly. ' +
      'We have provided a recording of their initial call for your convenience.',
  },

  UNABLE_LOAD_OLD_CONVERSATIONS: `Sorry, we're having issues and couldn't load older conversations.\n We apologize for the inconvenience.`,
  DATE_FNS_FORMAT: 'h:mm a',
  FAILED_SEND_TEXT: `This message didn't send. Click here to try again`,
  SENDING_SEND_TEXT: 'Sending...',

  QUERY: {
    hotpads: 'RH_getHotpadsUser',
    zillow: 'RH_getZillowUser',
    trulia: 'RH_getTruliaUser',
  },

  SYNDICATION: {
    STATUS: {
      POSTED: 'POSTED',
      NOT_ATTEMPTED: 'SYNDICATION_NOT_ATTEMPTED',
    },
  },

  ATTACHMENTS: {
    IMAGE_FILE_TYPE: 'image', // use with .includes since an image can be image/jpg, image/png, etc.
    VIDEO_FILE_TYPE: 'video', // use with .includes since a video can be .mp4, .mov, etc.
    IMPERSONATION_DETECTED: 'impersonation-detected',
    STATUS_COMPLETE: 'complete',
  },

  START_CONVERSATION_TEXT: 'This is the start of your conversation',

  WARNING_MESSAGE: {
    text: 'Be cautious of requests for sensitive personal information. \
      Also, be wary of instructions to wire money or pay fees before viewing \
      a property or signing a lease.',
    url: 'https://www.zillow.com/learn/how-to-spot-rental-scams/',
  },
};

export default StringConstants;
